import {ProductState} from "../../../../interfaces/ProductComponentState";
import React from "react";
import ImageZoom from "./ImageZoom";
import BtnAddToCart from "../../BtnAddToCart/BtnAddToCart";
import AppSettingController from "../../../../../Main/controller/AppSettingController";
import {useTranslation} from "react-i18next";

export default function ModalBody({item}: { item: ProductState }) {
    const {t, i18n} = useTranslation();
    const lang = i18n.language === 'ar-IQ' ? 'ar-IQ' : 'fa-IR';

    return (
        <div className="modal-body-container">
            <div className={'product-image-modal-container'}>
                <ImageZoom image={item.image}/>
            </div>
            <div className="product-info">
                <div className="product-description">
                    <h1>{item.title}</h1>
                    <p>{item.description}</p>
                </div>
                <div className="product-price">
                    <data value={item.price} style={{visibility: AppSettingController.isHiddenPrice() ? "hidden" : "visible"}}>
                        {item.price.toLocaleString(lang)}
                        <bdi>{item.currency}</bdi>
                    </data>
                    <div>
                        <button onClick={() => window.dispatchEvent(new Event('closeModal'))} className="btn-back">
                            {t("close")}
                        </button>
                        <BtnAddToCart item={item}/>
                    </div>
                </div>
            </div>
        </div>
    );
}
